export default function TermsPage() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold mb-8">Terms and Conditions</h1>
      <div className="prose prose-invert prose-gray max-w-none space-y-6 text-gray-300 leading-relaxed">
        <p className="text-sm text-gray-500">Last updated: March 2026</p>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">1. Acceptance of Terms</h2>
          <p>
            By accessing or using Nokset ("the Service"), you agree to be bound by these
            Terms and Conditions ("Terms"). If you do not agree to these Terms, you must
            not use the Service. We reserve the right to modify these Terms at any time.
            Continued use of the Service after changes constitutes acceptance of the modified Terms.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">2. Description of Service</h2>
          <p>
            Nokset is a band management platform that allows bands to create public profiles,
            manage their event calendars, organise setlists, and manage band membership.
            The Service provides both public-facing band pages and private management tools.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">3. User Accounts</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>You must provide accurate and complete information when creating an account.</li>
            <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
            <li>You are responsible for all activities that occur under your account.</li>
            <li>You must notify us immediately of any unauthorised use of your account.</li>
            <li>You must be at least 13 years of age to create an account.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">4. User Content</h2>
          <p>
            You retain ownership of all content you post on the Service ("User Content"),
            including band descriptions, event details, setlists, and uploaded images.
          </p>
          <p className="mt-2">By posting User Content, you grant Nokset a non-exclusive, worldwide, royalty-free licence to:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Display your public content on the Service</li>
            <li>Store and process your content to provide the Service</li>
            <li>Make your public content available to other users of the Service</li>
          </ul>
          <p className="mt-2">You represent and warrant that:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>You own or have the right to post the content you submit</li>
            <li>Your content does not infringe on any third party's rights</li>
            <li>Your content does not violate any applicable laws</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">5. Acceptable Use</h2>
          <p>You agree not to:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Use the Service for any unlawful purpose</li>
            <li>Post false, misleading, or fraudulent content</li>
            <li>Impersonate any person or entity</li>
            <li>Upload malicious code, viruses, or harmful content</li>
            <li>Attempt to gain unauthorised access to the Service or other user accounts</li>
            <li>Use the Service to send unsolicited communications (spam)</li>
            <li>Interfere with or disrupt the Service or its infrastructure</li>
            <li>Scrape or collect user data without consent</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">6. Band Management</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Band owners are responsible for the content on their band's public page.</li>
            <li>By inviting members to a band, you confirm you have their consent to share their email address with the Service.</li>
            <li>Band admins and owners can manage band settings, members, and content.</li>
            <li>Nokset is not responsible for disputes between band members.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">7. Intellectual Property</h2>
          <p>
            The Nokset name, logo, and the design of the Service are the intellectual property
            of Nokset and are protected by applicable intellectual property laws. You may not
            use our intellectual property without our prior written consent.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">8. Disclaimer of Warranties</h2>
          <p>
            The Service is provided "as is" and "as available" without warranties of any kind,
            either express or implied. We do not warrant that the Service will be uninterrupted,
            error-free, or secure. We do not warrant the accuracy of any information provided
            by users of the Service.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">9. Limitation of Liability</h2>
          <p>
            To the fullest extent permitted by law, Nokset shall not be liable for any indirect,
            incidental, special, consequential, or punitive damages, or any loss of profits or
            revenues, whether incurred directly or indirectly, or any loss of data, use, or goodwill.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">10. Termination</h2>
          <p>
            We may terminate or suspend your access to the Service at any time, with or without cause,
            with or without notice. Upon termination, your right to use the Service will immediately cease.
            You may delete your account at any time by contacting us.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">11. Governing Law</h2>
          <p>
            These Terms shall be governed by and construed in accordance with the laws of
            the Bailiwick of Guernsey, without regard to its conflict of law provisions.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-50 mt-8 mb-3">12. Contact Us</h2>
          <p>
            If you have any questions about these Terms, please contact us at legal@nokset.com.
          </p>
        </section>
      </div>
    </div>
  );
}
